import * as z from "zod";

// This is necessary for optional fields because the Prisma generated Go models
// do not add `omitempty` to the struct tags and empty values are serialised to
// `null` in the resulting JSON. Formik/React do not like this so this fixes it
const nulptional = (s: z.ZodSchema<any>) =>
  s.nullish().transform((v) => (v === null ? undefined : v));

export const StoreSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string(),
  description: z.string(),
  website: z.string(),

  distance: z.number(),
  time: z.number(),
  lat: z.number(),
  lng: z.number(),
  directions: z.string(),
  mapsLink: z.string(),
});
export type Store = z.infer<typeof StoreSchema>;

export const ProfileSchema = z.object({
  id: z.string(),
  email: z.string(),
  postcode: nulptional(z.string()),
  radius: nulptional(z.number()),
});
export type Profile = z.infer<typeof ProfileSchema>;

export const StoredProfileSchema = z.object({
  profile: ProfileSchema,
  jwt: z.string(),
});
export type StoredProfile = z.infer<typeof StoredProfileSchema>;
